export * from './app-aside.component';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/components/app-aside/index.ts